<template>
  <div class="min-h-screen bg-primaryBg font-inter">
    <div class="w-full">
      <main class="w-full">
        <!-- Breadcrumb Header -->
        <nav class="w-full bg-white border-b border-grayLight h-[56px] px-8 flex justify-between items-center">
          <div class="flex space-x-3 items-center">
            <TIIcon class="w-4 h-4 mr-1 text-gray-400" />
            <img src="@/assets/dashboard/chevron-right.svg" alt="Chevron icon" class="h-3" />
            <router-link to="/talent-pool" class="text-[13px] font-medium text-gray-500 hover:text-primaryDark transition-colors">
              Talent Intelligence
            </router-link>
            <img src="@/assets/dashboard/chevron-right.svg" alt="Chevron icon" class="h-3" />
            <p class="font-medium text-[13px] text-primaryDarkBg px-2 py-1">
              Talent Profile
            </p>
          </div>
          
          <div class="flex items-center gap-4">
            <button class="p-2 text-gray-400 hover:text-primaryDark">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.02 2.91C8.71 2.91 6.02 5.6 6.02 8.91V11.1c0 .5-.16 1.28-.46 1.73l-1.4 2.1c-.84 1.26-.26 2.62 1.29 3.03 2.82.74 5.75.74 8.57 0 1.45-.38 2.06-1.85 1.29-3.03l-1.4-2.1c-.3-.45-.46-1.23-.46-1.73V8.91c0-3.3-2.69-6.00002-6.02-6.00002Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
                <path d="M13.87 18.89c-.11 0-.22.01-.33.01.03.43-.14.86-.44 1.21-.37.42-.91.66-1.47.66-.56 0-1.1-.24-1.47-.66-.3-.35-.47-.78-.44-1.21-.11 0-.22-.01-.33-.01-1.03 0-1.87.84-1.87 1.87 0 1.03.84 1.87 1.87 1.87s1.87-.84 1.87-1.87c.18 0 .33-.11.44-.24.11.13.26.24.44.24 1.03 0 1.87-.84 1.87-1.87s-.84-1.87-1.87-1.87Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10"/>
              </svg>
            </button>
            <div class="flex items-center gap-2">
              <div class="w-8 h-8 rounded-full bg-primaryDark text-white flex items-center justify-center text-[12px] font-bold">
                CI
              </div>
            </div>
          </div>
        </nav>

        <TalentProfileComponent />
      </main>
    </div>
  </div>
</template>

<script>
import TalentProfileComponent from '@/components/talents/TalentProfileComponent.vue';
import TIIcon from '@/components/svg-icons/TIIcon.vue';

export default {
  name: 'TalentProfileView',
  components: {
    TalentProfileComponent,
    TIIcon
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>
